import React, { useEffect, useRef, useState } from 'react';
import styles from './UserAssignment.module.css';
import WhiteBoxContainer from '../../../HOC/WrappingContainer/WhiteBoxContainer';
import TableTopHeader from '../../TableTopHeader/TableTopHeader';
import * as tableHeader from '../../TableHeader/UsersAssignmentHeader';
import ColumnVisibility from '../../TableTopHeader/ColumnVisibility';
import Filter from '../../TableTopHeader/Filter';
import TableComponent from '../../TableComponent/TableComponent';
import bulkIcon from '../../../../assets/Imagess/Users/UsersAssignment/bulkIcon.svg';
import automaticAssign from '../../../../assets/Imagess/Users/UsersAssignment/automaticAssign.svg';
import SelectedNumberComponent from '../../TableTopHeader/SelectedNumberComponent';
import ColoredButton from '../../../Atoms/Buttons/ColoredButtons/ColoredButton';
import AssignModal from '../AssignModal';
import Tooltip from '../../../Atoms/Tooltip/Tooltip';
import TableFilter from '../../Custom/TableFilter/TableFilter';
import Loader from '../../Loader/Loader';
import PrintComponent from '../../Custom/ExportComponent/PrintComponent';
import { useReactToPrint } from 'react-to-print';
import { useExportShowResult } from '../../../../Hooks/UserAssignment';
import AssignUserModal from '../../Users/RolesModal/AssignUserModal';
const UsersAssignment = ({
  usersAssignmentData,
  setOrderBy,
  setOrderDir,
  orderDir,
  orderBy,
  refetch,
  handleShowResult,
  search,
  setSearch,
  isShowingUsrsAssignment,
  setFilterByField,
  isShowResult,
  valuesToExport,
  filterByField,
  payload,
}) => {
  const printRef = useRef();

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isAssignUser, setIsAssignUser] = useState({
    isAssigned: false,
    assignTitle: '',
  });
  const [visibleColumn, setVisibleColumn] = useState({
    fullName: true,
    firstName: false,
    lastName: false,
    // middleName: false,
    applicationStart_Display: true,
    fieldOfInterest_Display: true,
    mobile: false,
    email: false,
    contactType_Display: false,
    userAssigned: true,
    statusText: false,
    type: true,
    nationality_Display: true,
    howDoYouHear_Display: false,
    // selectedTerm_Display: true,
    noteCount: false,
    emailCount: false,
    sourceOfConnection: false,
    grade_Display: false,
    highSchoolGPA: false,
    curriculum_Display: false,
    lastEmailReceivedOnDisplay: false,
    priority_Display: false,
    country_Display: false,
    jobTitle: false,
    schoolName: false,
    createdOnDisplay: false,
  });

  const [isFilter, setIsFilter] = useState(false);
  const exportShowResult = useExportShowResult();

  const combinedData = usersAssignmentData
    ? [
        ...(Array.isArray(usersAssignmentData?.applicants)
          ? usersAssignmentData.applicants.map((applicant) => ({
              ...applicant,
              type: 'applicant',
              id: applicant.applicantId,
              fullName: applicant.lastName
                ? applicant.firstName +
                  ' ' +
                  applicant.middleName +
                  ' ' +
                  applicant.lastName
                : applicant.firstName,
            }))
          : []),
        ...(Array.isArray(usersAssignmentData?.externalContacts)
          ? usersAssignmentData.externalContacts.map((contact) => ({
              ...contact,
              type: 'contact',
              id: contact.externalContactId,
              fullName: contact.contactName,
            }))
          : []),
        ...(Array.isArray(usersAssignmentData?.leads)
          ? usersAssignmentData.leads.map((lead) => ({
              ...lead,
              type: 'lead',
              id: lead.studentId,
              fullName: lead.lastName
                ? lead.firstName + ' ' + lead.lastName
                : lead.firstName,
            }))
          : []),
      ]
    : [];

  const tableData = {
    data: {
      items: combinedData.map((item) => ({
        ...item,
        id: item.id,
      })),
    },
    tableHeader: tableHeader.userHeader,
    isLoading: isShowingUsrsAssignment,
    refetch: null,
  };

  useEffect(() => {
    handleShowResult();
  }, [isFilter, filterByField]);

  const customizedColumn = (item) => (
    <Tooltip content='Assign User'>
      <img
        src={automaticAssign}
        alt='automatic'
        onClick={(e) => {
          e.stopPropagation();
          setSelectedStudents((prevSelectedStudents) => [
            ...prevSelectedStudents,
            { id: item.id },
          ]);
          setIsAssignUser((prev) => ({
            ...prev,
            assignTitle: 'Assign User',
            isAssigned: true,
          }));
        }}
      />
    </Tooltip>
  );

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const additionalButtons = (
    <>
      <div className={`${styles['number']}`}>
        {selectedStudents?.length !== 0 && (
          <SelectedNumberComponent selected={selectedStudents?.length} />
        )}
      </div>
      {selectedStudents?.length !== 0 && (
        <>
          <ColoredButton
            title='Bulk Assign'
            blue
            rounded={true}
            icon={bulkIcon}
            handleOnClick={() =>
              setIsAssignUser((prev) => ({
                ...prev,
                assignTitle: 'Bulk Assign',
                isAssigned: true,
              }))
            }
          />
          {selectedStudents.length > 1 ? (
            <ColoredButton
              title='Automatic Assign'
              unfilled
              rounded={true}
              icon={automaticAssign}
              handleOnClick={() =>
                setIsAssignUser((prev) => ({
                  ...prev,
                  assignTitle: 'Automatic Assign',
                  isAssigned: true,
                }))
              }
            />
          ) : (
            ''
          )}
        </>
      )}
    </>
  );

  const rightButtons = (
    <>
      <ColumnVisibility
        visibleColumn={visibleColumn}
        setVisibleColumn={setVisibleColumn}
        tableHeader={tableHeader.userHeader}
      />
      {/* <TableFilter
        isFilter={isFilter}
        setIsFilter={setIsFilter}
        setFilterByField={setFilterByField}
      /> */}
    </>
  );
  return (
    <>
      <WhiteBoxContainer>
        <TableTopHeader
          rightButtons={rightButtons}
          additionalButtons={additionalButtons}
          isSearch
          search={search}
          setSearch={setSearch}
          handlePrint={handlePrint}
          exportData={{
            visibleColumn: visibleColumn,
            tableHeader: tableHeader.userHeader,
            fileName: 'UserAssignmentExport',
            combinedData: tableData?.data?.items,
            isData: true,
          }}
        />

        <TableComponent
          tableData={tableData}
          checkBox={true}
          // pagination={true}
          setSelected={setSelectedStudents}
          selected={selectedStudents}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setOrderBy={setOrderBy}
          setOrderDir={setOrderDir}
          orderDir={orderDir}
          orderBy={orderBy}
          customizedColumn={customizedColumn}
          visibleColumn={visibleColumn}
          columnVisibility={true}
          isOrder
          isLoading={isShowingUsrsAssignment}
          isFilter={isFilter}
          setFilterByField={setFilterByField}
          isResize
        />
      </WhiteBoxContainer>
      {(isAssignUser.assignTitle == 'Bulk Assign' ||
        isAssignUser.assignTitle == 'Assign User') && (
        <AssignModal
          handleOnClose={() => (
            setIsAssignUser((prev) => ({ ...prev, assignTitle: '' })),
            setSelectedStudents([])
          )}
          title={isAssignUser.assignTitle}
          selected={selectedStudents}
          setSelected={setSelectedStudents}
          refetch={refetch}
        />
      )}
      {isAssignUser.assignTitle == 'Automatic Assign' && (
        <AssignUserModal
          handleOnClose={() => (
            setIsAssignUser((prev) => ({ ...prev, assignTitle: '' })),
            setSelectedStudents([])
          )}
          selected={selectedStudents}
          setSelected={setSelectedStudents}
          refetch={refetch}
          title='Automatic Assign'
        />
      )}
      <div style={{ display: 'none' }}>
        <PrintComponent
          ref={printRef}
          title='User Assignment'
          data={tableData}
        />
      </div>
    </>
  );
};

export default UsersAssignment;
